import { render, staticRenderFns } from "./AnalisisLaboratorio.vue?vue&type=template&id=1fb76db6&"
import script from "./AnalisisLaboratorio.vue?vue&type=script&lang=js&"
export * from "./AnalisisLaboratorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports